import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, ref } from 'vue-demi';
import { useCdnImg } from '@webplatform/cdn-image';
import { AbIcon } from '../../../ui';

interface Props {
  src: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SocialSectionInstagramVideo',
  props: {
    src: null
  },
  emits: ["autoplay-toggle"],
  setup(__props: any, { emit }: { emit: ({ (e: 'autoplay-toggle', value: boolean): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  src: string;
};




const { generateUrl } = useCdnImg();

const cdnSrc = computed(() => (props.src ? generateUrl(props.src, {}) : ''));

const videoEl = ref<HTMLVideoElement | null>(null);
const play = ref(false);

const applyState = async (shouldPlay: boolean) => {
  await nextTick();
  const el = videoEl.value;
  if (!el) return;
  try {
    if (shouldPlay) await el.play();
    else el.pause();
  } catch (_) {}
};

const togglePlay = () => {
  play.value = !play.value;
  applyState(play.value);
  emit('autoplay-toggle', play.value);
};

return { __sfc: true,props, emit, generateUrl, cdnSrc, videoEl, play, applyState, togglePlay, AbIcon }
}

})